import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'tc-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './content.component.html',
  styleUrl: './content.component.css',
})
export class ContentComponent {}
